<template>
  <div>
    <el-dialog :title="$t('componentMsg.020')" :visible.sync="isDialogVisible" @close="handleClose" width="44%" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 二维码 -->
      <div class="qrcode-content">
        <div class="qrdiv" v-show="qrCodeArr.length != 0">
          <div class="qrcode" v-for="(_, i) in qrCodeArr" :key="i">
            <span class="qrCodeTitle">{{qrCodeTitle}} {{ i+1 }}</span>
            <canvas :ref="`qrCode${i}`" class="qrcode-img"></canvas>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { txtToQRtxt } from "@/utils/qrCodeFunctions";
import QRCode from 'qrcode';
export default {
  // 引入二维码处理方法
  name: "showQRCode",
  props: {
    // 接收一个prop来控制二维码的显示
    showDialog: {
      type: Boolean,
      default:false
    },
    // 二维码内容
    qrCodeTxt: {
      type: String,
      default:''
    },
    // 二维码标题
    qrCodeTitle: {
      type: String,
      default:''
    },
  },
  data() {
    return {
      qrCodeArr: [], // 二维码数组
      isDialogVisible: this.showDialog
    };
  },
  watch: {
    showDialog(newVal) {
      this.isDialogVisible = newVal;
      if (newVal) this.updateQRCode();
    },
    qrCodeTxt() {
      if (this.isDialogVisible) this.updateQRCode();
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:showDialog", false);
      this.clearQrcode();
      this.qrCodeArr = [];
    },
    // 循环生成二维码
    async forQRcode(arr) {
      await this.$nextTick();
      for (let j = 0; j < arr.length; j++) {
        let el = this.$refs[`qrCode${j}`];
        // Vue2 中 v-for 的动态 ref 可能是数组
        if (Array.isArray(el)) el = el[0];
        if (el) {
          await this.createQRCode(el, arr[j]);
        }
      }
    },
    // 生成二维码
    async createQRCode(el, code) {
      await QRCode.toCanvas(el, code, {
        width: 200,
        margin: 0,
        color: {
          dark: '#000',
          light: '#fff'
        },
        errorCorrectionLevel: 'L'
      });
    },
    updateQRCode() {
      if (this.qrCodeTxt !== '') {
        this.qrCodeArr = txtToQRtxt(this.qrCodeTxt, '<stn2>');
        this.forQRcode(this.qrCodeArr);
      }
    },
    // 清除上一次二维码
    clearQrcode() {
      for (let i = 0; i < this.qrCodeArr.length; i++) {
        let el = this.$refs[`qrCode${i}`];
        if (Array.isArray(el)) el = el[0];
        if (el && el.getContext) {
          const ctx = el.getContext('2d');
          ctx.clearRect(0, 0, el.width, el.height);
        }
      }
    }
  }
};
</script>
<style scoped>
.qrdiv{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.qrcode{
  margin: 10px;
}
</style>
